// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2Fqy0","label":"LabeledBox_label__2LAnx"};